/**
 * Created by Ganesh.Sharma on 02-01-2017.
 */
define(['edge/platform/base/BaseCtrl','underscore','text!customerEdge/quoteandbind/common/views/electronic-payment-terms-modal.html'], (BaseCtrl, _, TermsTemplate)=> {
    const fn = function (filter, $scope, $state, $stateParams, submissionViewModel, $modal, $modalStack, StateUtils) {
        const ctrl = Object.create(BaseCtrl);
        const submissionVM = submissionViewModel();
        const flowModel = StateUtils.activeDataForState(true).flowModel;

        ctrl.init = function () {

            angular.forEach(submissionVM.value.bindData.paymentPlans,function(x){
                if(x.billingId === submissionVM.value.bindData.selectedPaymentPlan){
                    $scope.downPayment = x.downPayment.amount.toFixed(2);
                }
            });

            var displayName = submissionVM.value.bindData.paymentDetails.creditCardData.displayName;

            displayName = displayName.substring(0,displayName.length-5)+"exp "+displayName.substring(displayName.length-5,displayName.length)

            $scope.info = {
                'displayName': displayName,
                'token': submissionVM.value.bindData.paymentDetails.creditCardData.token
            };

            $scope.payment = {
                terms : false,
                selectedItem : false
            }
        };

        ctrl.showTerms = function () {
            var modalInstance = $modal.open({
                backdrop  :'static',
                keyboard  : false,
                template: TermsTemplate,
                controller: function($scope){
                    $scope.close = function (evt) {
                        const modal = $modalStack.getTop();
                        if (modal && modal.value.backdrop) {
                            evt.preventDefault();
                            evt.stopPropagation();
                            $modalStack.dismiss(modal.key, 'backdrop click');
                        }
                    };
                },
            });
        };

        ctrl.next = (form)=> {
            form.submitted = true;
            if($scope.payment.selectedItem == undefined || $scope.payment.selectedItem == false || $scope.payment.terms == false || $scope.payment.terms == undefined ){
                return false;
            }


            flowModel.next(submissionVM);
        };

        ctrl.cancel = function () {
            flowModel.previous(submissionVM);
        };


        return ctrl.create($scope);
    };
fn.$inject = ['$filter', '$scope', '$state', '$stateParams','submissionViewModel', '$modal', '$modalStack', 'StateUtils'];
return fn;
});



/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/quoteandbind/common/controllers/PaymentConfirmationCtrl.js
 **/